module.exports = __webpack_public_path__ + "gengji_banner.png?1aff7b93d058cd3db8d35f8e00b1cb99";